<template>
    <div class="modal fade" id="buy-membership-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header text-secondary">
                    <h5 class="modal-title" id="exampleModalLabel">Quick buy</h5>
                </div>
                <div class="modal-body">
                    <PaymentCreditCard />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close()">Cancel</button>
                    <button type="button" class="btn btn-primary">Proceed</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PaymentCreditCard from "../forms/PaymentCreditCard";
export default {
    name: "BuyMembershipModal",
    components: {PaymentCreditCard},
    data() {
        return {
            modal: null,

        }
    },
    mounted() {
        this.modal = new bootstrap.Modal(document.getElementById('buy-membership-modal'));
    },
    methods: {
        open() {
            this.modal.show();
            return this;
        },
        close() {
            this.modal.hide();
        },
    }
}
</script>

<style scoped>

</style>
